import React, { Component } from "react";
//import Button from "./shared/Button";
import CloseIcon from "./icons/CloseIcon";

class SupportQuestionAnswer extends Component {
  constructor(props) {
    super(props);

    this.state = { isToggleOn: true };
    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
  }

  render() {
    const question = this.props.question;
    const answer = this.props.answer;
    const boldWords = this.props.boldWords;
    const boldWords2 = this.props.boldWords2;

    /**
     * Find and highlight relevant keywords within a block of text
     * @param  {string} label - The text to parse
     * @param  {string} value - The search keyword to highlight
     * @return {object} A JSX object containing an array of alternating strings and JSX
     * //formatLabel('Lorem ipsum dolor sit amet', 'dolor');
     * // <span>Lorem ipsum <b>dolor</b> sit amet</span>
     */
    const formatLabel = (label, value, value2) => {
      if (!value) {
        return label;
      }
      return (
        <span>
          {label.split(value).reduce((prev, current, i) => {
            if (!i) {
              return [current];
            }
            prev = prev.concat(
              <span className="font-bold" key={value + current}>
                {value}
              </span>
            );

            if (value2) {
              current
                .split(value2)
                // eslint-disable-next-line
                .reduce((prev2, current2, i) => {
                  if (!i) {
                    return [current2];
                  }
                  prev = prev.concat(
                    prev2,
                    <span className="font-bold" key={value2 + current2}>
                      {value2}
                    </span>,
                    current2
                  );
                }, []);
            } else {
              prev = prev.concat(current);
            }

            return prev;
            //              return prev.concat(<b key={value + current}>{ value }</b>, current);
          }, [])}
        </span>
      );
    };

    return (
      <div className="grid__item support__item" onClick={this.handleClick}>
        {this.state.isToggleOn ? (
          <div className="support__question">
            <div className="support__question__text flex h-100 items-center justify-center">
              {formatLabel(question, boldWords, boldWords2) }
            </div>
            {/*                <div className="support__question__arrow">
                    <Button
                    icon="button__icon--arrow-right i-arrow-right-light"
                    />
                  </div>
  */}
          </div>
        ) : (
          <div className="support__question">
            <div className="support__question__close">
              <CloseIcon height={"24px"} />
            </div>
            <div className="support__question__text flex h-100 items-center">
              {answer}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SupportQuestionAnswer;



// WEBPACK FOOTER //
// ./src/components/SupportQuestionAnswer.js